import { render, staticRenderFns } from "./VxInputFabric.vue?vue&type=template&id=3e927314&"
import script from "./VxInputFabric.vue?vue&type=script&lang=js&"
export * from "./VxInputFabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports